<q9-content-loader [isLoading]="loading()"></q9-content-loader>

<form novalidate #form="ngForm" *ngIf="!loading()" [formGroup]="createProposedNodeForm">
  <div mat-dialog-title>
    <span>{{ 'POPUPS.ADD_PROPOSED_NODE' | translate: {type: proposedNodeType} }}</span>
    <q9-dialog-close-button (click)="closeModal()"></q9-dialog-close-button>
  </div>

  <q9-info-message *ngIf="error" type="error">{{ error | translate }}</q9-info-message>

  <mat-dialog-content>
    <q9-proposed-node-form
      [proposedNodeType]="proposedNodeType"
      [form]="createProposedNodeForm"></q9-proposed-node-form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <q9-secondary-button (click)="closeModal()" [isLoading]="loading()">
      {{ 'POPUPS.CANCEL' | translate }}
    </q9-secondary-button>

    <q9-secondary-button
      (click)="form.onSubmit($event); !loading() && onSubmit(true)"
      [isLoading]="loading()">
      {{ 'POPUPS.CREATE_AND_NEW' | translate }}
    </q9-secondary-button>

    <q9-primary-button
      (click)="form.onSubmit($event); !loading() && onSubmit()"
      [isLoading]="loading()">
      {{ 'POPUPS.CREATE' | translate }}
    </q9-primary-button>
  </mat-dialog-actions>
</form>
